// plugins/timestampDateOnly.ts
import { defineNuxtPlugin } from '#app';
import formatDatabaseDateOnly from '~/utils/formatDatabaseDateOnly';

export default defineNuxtPlugin((nuxtApp) => {
    const timestampDateOnly = (value) => {
        if (!value) return '';
        return formatDatabaseDateOnly(value);
    };

    // 1) make it available as `$timestampDateOnly()` in your templates and Options API:
    nuxtApp.vueApp.config.globalProperties.$timestampDateOnly = timestampDateOnly;

    // 2) also provide it via `useNuxtApp().$timestampDateOnly` in the Composition API:
    nuxtApp.provide('timestampDateOnly', timestampDateOnly);
});
